/* src/app/user-access-history/user-access-history.component.scss */
@media screen and (max-width: 767px) {
  :host ::ng-deep .breadcrumbs > .row {
    padding-left: 0;
    margin-left: 0 !important;
  }
}
.user-access-history {
  height: 100%;
  display: flex;
  flex-direction: column;
}
@media screen and (max-width: 767px) {
  .user-access-history {
    height: 83vh;
    width: 90%;
    margin: auto;
    margin-top: -34px;
    min-height: 520px;
  }
  .user-access-history .page-header {
    line-height: 1.3;
  }
  .user-access-history .round-button {
    margin-left: 0;
  }
  .user-access-history > * {
    margin: auto;
    width: 100% !important;
  }
}
.user-access-history .search-container {
  width: 310px;
  padding-top: 25px;
}
.user-access-history .audit-container {
  position: relative;
  padding-top: 16px;
  min-height: 17.25rem;
  max-height: 45vh;
}
@media screen and (min-width: 992px) {
  .user-access-history .audit-container {
    width: 60%;
  }
}
@media screen and (min-width: 768px) and (max-width: 991px) {
  .user-access-history .audit-container {
    width: 100%;
  }
}
@media screen and (max-width: 767px) {
  .user-access-history .audit-container {
    padding-top: 34px;
    min-height: 11em;
  }
  .user-access-history .audit-container .audit-grid-header {
    display: none;
  }
  .user-access-history .audit-container .audit-grid-body {
    padding-top: 12px;
    width: 100%;
    min-height: 9em;
  }
  .user-access-history .audit-container .entry-count {
    right: 0;
  }
}
.user-access-history .round-button {
  max-width: fit-content;
  margin-top: 25px;
  margin-bottom: 32px;
}
.user-access-history .page-header {
  font-size: 32px;
  margin-bottom: 8px;
}
.user-access-history .audit-grid-header {
  display: grid;
  grid-template-columns: minmax(0, 1.3fr) minmax(0, 1.5fr) minmax(0, 1.1fr) minmax(0, 2.2fr) minmax(0, 2fr) minmax(max-content, 0.7fr);
  margin: 0 15px;
}
.user-access-history .audit-grid-header span {
  font-size: 12px;
  color: #6e6e6e;
}
.user-access-history .entry-count {
  position: absolute;
  top: 0.9rem;
  right: -1rem;
  font-size: 14px;
  text-align: right;
  color: #404040;
}
.user-access-history .audit-grid-body {
  border: 1px solid #757575;
  min-height: 15rem;
  max-height: calc(100% - 1.25rem);
  scrollbar-gutter: stable;
  width: calc(100% + 1rem);
}
@media screen and (max-width: 767px) {
  .user-access-history .audit-grid-body {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
}
.user-access-history .audit-grid-body .audit-row {
  height: 24px;
  margin-left: 12px;
  margin-right: 12px;
  display: grid;
  grid-template-columns: minmax(0, 1.3fr) minmax(0, 1.5fr) minmax(0, 1.1fr) minmax(0, 2.2fr) minmax(0, 2fr) minmax(max-content, 0.7fr);
  grid-auto-rows: minmax(1.5rem, max-content);
}
@media screen and (max-width: 767px) {
  .user-access-history .audit-grid-body .audit-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    column-gap: 15px;
    margin-bottom: 5px;
  }
  .user-access-history .audit-grid-body .audit-row span {
    display: inline-block;
    width: fit-content;
    line-height: 1.2;
    min-width: 1px;
  }
}
.user-access-history .audit-grid-body .audit-row .audit-slic-name {
  width: 60px !important;
}
.user-access-history .audit-grid-body .audit-row .audit-role {
  min-width: 200px !important;
}
.user-access-history .audit-grid-body .audit-row .audit-activity {
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
/*# sourceMappingURL=user-access-history.component.css.map */
